import React from 'react';

const Logo: React.FC = () => <img src="/logo2.png" alt="Logo" width="120" height="120" />;

export default Logo;
